<template>
  <div v-if="$store.state.app.pageShow == 'resume-management'">
    <div class="myteamDtlTbl detail-tabl mb-3 resumeTable" :class="{ 'myteamTbl': items && items.length > 0 }">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3>Resumes</h3>
        <b-button variant="primary" class="btnViewsumm" @click="openAddModal">
          + Add Resume
        </b-button>
      </div>

      <!-- Loader -->
      <TableLoader v-if="loading" :fields="tableFields" />

      <!-- Table -->
      <b-table
        v-else-if="items && items.length > 0"
        :items="items"
        :fields="tableFields"
        :sticky-header="stickyHeader"
        :no-border-collapse="noCollapse"
        responsive
      >
        <!-- Google Drive Link -->
        <template
          #cell(google_drive_link)="data"
          class="justify-content-center"
        >
          <div v-if="data.item.google_drive_link">
            <a :href="data.item.google_drive_link" target="_blank">Open Link</a>
          </div>
          <div v-else>
            <span> - </span>
          </div>
        </template>

        <!-- Resume File -->
        <template #cell(url)="data">
          <div v-if="data.item.url" class="d-flex align-items-center">
            <!-- View Icon -->
            <div
              data-tooltip-id="View"
              data-tooltip-content="View"
              class="cursor-pointer mr-2"
              @click="openFileInNewTab(data.item.url)"
            >
              <feather-icon icon="EyeIcon" class="edit-icon" size="18" />
            </div>

            <!-- Download Icon -->
            <div
              data-tooltip-id="Download"
              data-tooltip-content="Download"
              class="cursor-pointer"
              @click="downloadFile(data)"
            >
              <feather-icon icon="DownloadIcon" class="edit-icon" size="18" />
            </div>
          </div>

          <div v-else>
            <span class="text-muted">No File</span>
          </div>
        </template>

        <template #cell(uploaded_by)="data">
          <div class="d-flex align-items-center new-time-report">
            <b-avatar size="30" :src="data.item.uploaded_by.picture" :text="(data.item.uploaded_by.full_name || '').split(' ')[0] | avatarText"
              style="background-color: #f97753" v-if="data.item.uploaded_by" />

            <div class="emp-detail">
              <p class="emp-name">
                {{ data.item.uploaded_by ? data.item.uploaded_by.full_name : "" }}
              </p>
            </div>
          </div>
        </template>

        <!-- Uploaded At -->
        <template #cell(created_at)="data">
          <div>{{ data.item.created_at | DateDDMMYYYYFormat }}</div>
        </template>

        <!-- Actions -->
        <template #cell(action)="data">
          <div v-if="userInfo && userInfo.role == 'SA'">
            <span v-b-tooltip.hover.top="'Edit'" @click="editMethod(data.item)">
              <feather-icon
                icon="EditIcon"
                size="18"
                style="color: #5e5873"
                role="button"
                class="mr-1"
              />
            </span>
            <span
              @click="deleteConfirmation(data.item.id)"
              v-b-tooltip.hover.top="'Delete'"
            >
              <feather-icon
                icon="Trash2Icon"
                size="18"
                style="color: #5e5873"
                role="button"
              />
            </span>
          </div>
        </template>
      </b-table>

      <!-- No Data Found -->
      <div v-else>
        <img
          src="../../assets/images/nodatafound/nodata.svg"
          alt="no-data"
          class="no-data-img"
          style="max-width: 340px;"
        />
      </div>
      <div>
        <validation-observer ref="clientObserver">
          <div class="addtask task-detail-modal">
            <b-modal
              id="AddResume"
              cancel-variant="outline-secondary"
              class="mymodal p-2"
              centered
              size="lg"
              @open="clearModelData"
            >
              <template #modal-title>
                <h3 class="sprint-from-title sprint-bottom ml-0 mb-1 pb-50">
                  {{ edit ? "Update Resume" : "Add Resume" }}
                </h3>
              </template>

              <div>
                <b-row class="addtask-content">
                  <!-- Description (required) -->
                  <b-col cols="12">
                    <b-form-group label="Description" label-for="description">
                      <validation-provider #default="{ errors }" name="Description" rules="required|max:255">
                        <b-form-input
                          id="description"
                          v-model.trim="description"
                          placeholder="Description"
                          name="Description"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Google Drive Link (optional; either-or with file) -->
                  <b-col cols="12">
                    <b-form-group label="Google Drive Link" label-for="google_drive_link">
                      <validation-provider #default="{ errors }" name="Google Drive Link">
                        <b-form-input
                          id="google_drive_link"
                          v-model.trim="google_drive_link"
                          placeholder="Google Drive Link"
                          name="Google Drive Link"
                        />
                        <!-- VeeValidate errors for format, etc. -->
                        <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                        <!-- Live either-or error -->
                        <small class="text-danger" v-if="showEitherOrError && eitherOrError">
                          {{ eitherOrError }}
                        </small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <!-- Resume File (optional; either-or with link) -->
                  <b-col>
                    <vue-dropzone
                      class="my-file-up"
                      id="dropzone"
                      ref="myVueDropzone"
                      :options="dropzoneOptions"
                      @vdropzone-error="handleFileError"
                      @vdropzone-success="handleFileAdding"
                      @vdropzone-removed-file="removeFile"
                    />
                    <small class="text-danger">{{ FileErrorMsg }}</small>
                  </b-col>
                </b-row>
              </div>

              <template #modal-footer>
                <b-button
                  variant="primary"
                  :disabled="loader"
                  @click="validationForm"
                >
                  <b-spinner
                    v-if="loader"
                    small
                    class="spinner"
                  />
                  {{ edit ? "Update" : "Add" }}
                </b-button>
                <b-button class="cancel-all" @click="$bvModal.hide('AddResume')">Cancel</b-button>
              </template>
            </b-modal>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>


<script>
import mixinResumeManagement from "@/mixin/myTeam/resumeManagement/index.js";
import { BTable, BButton, BAvatar, BBadge } from "bootstrap-vue";
import TableLoader from "../../components/loaders/table-loading.vue";
import MyteamdtlShimmer from "../shimmer/MyteamdtlShimmer.vue";

export default {
  name: "ResumeManagement",
  mixins: [mixinResumeManagement],
  components: {
    BAvatar,
    TableLoader,
    MyteamdtlShimmer,
    BTable,
    BButton,
    BBadge,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables/_variables.scss";
@import "./../../assets/scss/component-css/masterSettingFilter.scss";
@import "..//../assets/scss/component-css/resumeManagement.scss";
</style>